import React, { Component, Fragment } from 'react';
import { forwardRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, Grid, Typography, Box } from '@mui/material';
import { FaArrowLeft, FaCheck, FaCheckCircle, FaFirstAid, FaPlus, FaUserPlus } from 'react-icons/fa';

import { getUsuarios } from '../../../redux/actions/useractions';
import { clearErrors } from '../../../redux/actions/dataactions';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { data } from 'browserslist';
import { getCliente } from '../../../redux/actions/dataactions';
import { agregarUsuario } from '../../../redux/actions/useractions'
import MyButton from '../../../utils/MyButton';



export class CrearUsuario extends Component {
  constructor() {
    super();
    this.state = {
      nombre: '',
      email: '',
      password: '',
      confirmPassword: '',
      handle: '',
      showPassword: false,
      showConfirmPassword: false,

      idprestador: '', // Obtenerlos al renderizar el componente
      tipouser: '',
      handleuser: '',

      ccnit: '',
      ciudad: '',
      direccion: '',
      telefono: '',

      errors: {},
      aprobado: {},
      open: false,
    };
  }

  componentDidMount() {
    this.props.getCliente(this.props.clienteId);
  }

  static getDerivedStateFromProps(props, state) {
    let newState = null;

    if (props.UI.errors && props.UI.errors !== state.errors) {
      newState = newState || {};
      newState.errors = props.UI.errors;
    } else if (!props.UI.errors && Object.keys(state.errors || {}).length > 0) {
      newState = newState || {};
      newState.errors = {};
    }

    if (props.UI.aprobado && props.UI.aprobado !== state.aprobado) {
      newState = newState || {};
      newState.aprobado = props.UI.aprobado;
    } else if (!props.UI.aprobado && Object.keys(state.aprobado || {}).length > 0) {
      newState = newState || {};
      newState.aprobado = {};
    }

    return newState;
  }

  handleOpen = () => {
    this.setState({ open: true });
    console.log(this.state.aprobado)
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleClose = () => {

    if (this.state.aprobado.mensaje) {
      this.props.getUsuarios(this.props.clienteId);
      this.setState({
        nombre: '',
        email: '',
        password: '',
        confirmPassword: '',
        handle: '',
        showPassword: false,
        showConfirmPassword: false,
        idprestador: '', // Sólo para asistencial o compras
        tipoprestador: '',
        tipouser: '',
        handleuser: '',
        ccnit: '',
        ciudad: '',
        direccion: '',
        nombre: '',
        telefono: '', open: false, errors: {}, aprobado: {}
      });
      console.log("Get Usuarios en el close")
    } else {
      this.props.clearErrors();
      console.log("Clear Errors en el close")
      this.setState({ open: false, errors: {}, aprobado: {} });
    }




  };

  handleSubmit = (event) => {
    event.preventDefault();
    const newUserData = {

      email: this.state.email,
      password: this.state.password,
      confirmPassword: this.state.confirmPassword,
      handle: this.state.handle,

      tipoprestador: this.props.tipouser,
      tipouser: this.state.tipouser,
      handleuser: this.props.handleuser,

      ccnit: this.state.ccnit,
      ciudad: this.state.ciudad,
      direccion: this.state.direccion,
      nombre: this.state.nombre,
      telefono: this.state.telefono,
    };
    console.log(newUserData)
    this.props.agregarUsuario(newUserData, this.props.clienteId);
  }

  render() {
    const { UI: { loading } } = this.props;
    const { errors } = this.state;
    const { aprobado } = this.props.UI;

    return (

      <Fragment>

        <div className='div-card-link' onClick={this.handleOpen}>
          <div className="dashing-cardcontent">
            <div className="dashing-cardtext">
              <p className="dashing-text-card">
                Crear nuevo usuario
              </p>
            </div>
            <div className="dashing-cardicon">
              <FaUserPlus color="#FFFFFF" className="dashing-icon" />
            </div>
          </div>
        </div>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm">
          <DialogTitle sx={{ color: '#03178C', fontWeight: 'bold' }}>
            Agregar usuario
          </DialogTitle>

          <DialogContent>

            {aprobado && aprobado.mensaje ? (

              <div className='div-aprobado'>
                <div className='div-icono-aprobado'>
                  <FaCheck color="#ffffff" className='icono-aprobado' />
                </div>
                <h2 className='text-aprobado'>¡Usuario creado exitosamente!</h2>
              </div>

            ) : (

              <form>
                {errors && errors.error && (
                  <FormHelperText error style={{ textAlign: 'center', fontSize: '1rem', marginBottom: '15px' }}>
                    {errors.error}
                  </FormHelperText>
                )}
                {errors && errors.general && (
                  <FormHelperText error style={{ textAlign: 'center', fontSize: '1rem', marginBottom: '15px' }}>
                    {errors.general}
                  </FormHelperText>
                )}

                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ color: '#03178C', fontWeight: 'bold', mb: 1 }}>
                      Datos del Usuario
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      type="text"
                      name="nombre"
                      id="nombre"
                      autoComplete="name"
                      label="Nombre de la persona"
                      value={this.state.nombre}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.nombre}
                      error={Boolean(errors.nombre)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth size="small" error={Boolean(errors.tipouser)}>
                      <InputLabel>Tipo Usuario</InputLabel>
                      {this.props.tipouser == 'IPS' ? (
                        <Select
                          required
                          name="tipouser"
                          id="tipouser"
                          value={this.state.tipouser}
                          onChange={this.handleChange}
                          label="Tipo Usuario"
                        >
                          <MenuItem value="">
                            <em>Ninguno</em>
                          </MenuItem>
                          <MenuItem value="Asistencial">Asistencial</MenuItem>
                          <MenuItem value="Compras">Compras</MenuItem>
                          <MenuItem value="Tecnico">Tecnico</MenuItem>
                        </Select>
                      ) : (
                        <Select
                          required
                          name="tipouser"
                          id="tipouser"
                          value={this.state.tipouser}
                          onChange={this.handleChange}
                          label="Tipo Usuario"
                        >
                          <MenuItem value="">
                            <em>Ninguno</em>
                          </MenuItem>
                          <MenuItem value="Asistencial">Asistencial</MenuItem>
                          <MenuItem value="Tecnico">Tecnico</MenuItem>
                        </Select>
                      )}
                      {errors.tipouser && <FormHelperText>{errors.tipouser}</FormHelperText>}
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      type="text"
                      name="handle"
                      id="handle"
                      autoComplete="username"
                      label="Handle/Username"
                      value={this.state.handle}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.handle}
                      error={Boolean(errors.handle)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      type="email"
                      name="email"
                      id="email"
                      label="Email"
                      autoComplete="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.email}
                      error={Boolean(errors.email)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="password"
                      id="password"
                      label="Contraseña"
                      type={this.state.showPassword ? 'text' : 'password'}
                      autoComplete="new-password"
                      value={this.state.password}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.password}
                      error={Boolean(errors.password)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="Toggle password visibility"
                              onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                              edge="end"
                            >
                              {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="confirmPassword"
                      id="confirmPassword"
                      label="Confirmar Contraseña"
                      type={this.state.showConfirmPassword ? 'text' : 'password'}
                      autoComplete="new-password"
                      value={this.state.confirmPassword}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.confirmPassword}
                      error={Boolean(errors.confirmPassword)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="Toggle password visibility"
                              onClick={() => this.setState({ showConfirmPassword: !this.state.showConfirmPassword })}
                              edge="end"
                            >
                              {this.state.showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2" sx={{ color: '#03178C', fontWeight: 'bold', mt: 1, mb: 1 }}>
                      Datos de Contacto (Opcionales/Adicionales)
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      type="number"
                      name="ccnit"
                      id="ccnit"
                      label="Cédula o NIT"
                      value={this.state.ccnit}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.ccnit}
                      error={Boolean(errors.ccnit)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      type="text"
                      name="ciudad"
                      id="ciudad"
                      label="Ciudad"
                      value={this.state.ciudad}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.ciudad}
                      error={Boolean(errors.ciudad)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      type="text"
                      name="direccion"
                      id="direccion"
                      label="Dirección"
                      autoComplete='street-address'
                      value={this.state.direccion}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.direccion}
                      error={Boolean(errors.direccion)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      type="number"
                      name="telefono"
                      id="telefono"
                      autoComplete='tel'
                      label="Teléfono del usuario"
                      value={this.state.telefono}
                      onChange={this.handleChange}
                      fullWidth
                      size="small"
                      helperText={errors.telefono}
                      error={Boolean(errors.telefono)}
                    />
                  </Grid>
                </Grid>
              </form>
            )}

          </DialogContent>

          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
            </MyButton>

            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : (
              aprobado && aprobado.mensaje ? (
                <MyButton tip="Continuar" onClick={this.handleClose}>
                  <FaCheckCircle color="#20B90C" className="icon-formulario" />
                </MyButton>
              ) : (
                <MyButton tip="Crear usuario" onClick={this.handleSubmit}>
                  <FaPlus color="#03178C" className="icon-formulario" />
                </MyButton>
              )
            )}

          </DialogActions>

        </Dialog>
      </Fragment>

    )
  }
}

CrearUsuario.propTypes = {
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  clienteId: PropTypes.string.isRequired,
  tipouser: PropTypes.string.isRequired,
  handleuser: PropTypes.string.isRequired,
}

const mapStateToProps = state => ({
  UI: state.UI,
  data: state.data,
  handleuser: state.user.credentials.handle,
  tipouser: state.data.cliente.tipouser
})

const mapActionsToProps = { clearErrors, getCliente, agregarUsuario, getUsuarios };


export default connect(mapStateToProps, mapActionsToProps)(CrearUsuario);